import {createSlice} from '@reduxjs/toolkit';

export const snackSlice = createSlice({
  name: 'snack',
  initialState: {
    slideIn: false,
    msg: '',
  },
  reducers: {
    setSlideIn: (state, action) => {
      state.slideIn = true;
      state.msg = action.payload;
    },
    removeSlideIn: (state) => {
      state.slideIn = false;
    },
  },
});

export const {setSlideIn, removeSlideIn} = snackSlice.actions;

export const selectSnack = (state) => state.snack.slideIn;
export const selectSnackMsg = (state) => state.snack.msg;

export default snackSlice.reducer;
